const PREFIX = 'ARCHIVES_'

/**
 * @name GET_PUBLICATIONS
 * @const
 * @description Get Publications Details
 */
export const GET_PUBLICATIONS = PREFIX + 'GET_PUBLICATIONS';

/**
 * @name SORT
 * @const
 * @description Applies sort to Publications
 */
export const SORT = PREFIX + 'SORT';

/**
 * @name FILTER
 * @const
 * @description Applies year filter Publications
 */
export const FILTER = PREFIX + 'FILTER';